import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { KanbanDeadlineProps } from '../types/interfaces'

import { formatMainDate } from '@shared/lib/format'

interface UseKanbanDeadlineOptions {
  props: KanbanDeadlineProps
}

interface UseKanbanDeadlineReturn {
  refFormattedDate: ComputedRef<string>
}

export const useKanbanDeadline = ({ props }: UseKanbanDeadlineOptions): UseKanbanDeadlineReturn => {
  const refFormattedDate = computed<string>(() => formatMainDate(props.value))

  return {
    refFormattedDate,
  }
}
